import { render, staticRenderFns } from "./StocksDSVTable.vue?vue&type=template&id=dbfabca8&"
import script from "./StocksDSVTable.vue?vue&type=script&lang=js&"
export * from "./StocksDSVTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports